import React from 'react';
interface SectionHeadingProps {
  id: string;
  title: React.ReactNode;
  eyebrow?: string;
  lead?: React.ReactNode;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  className?: string;
}

/** Serif section heading with an optional brass eyebrow (the premium accent). */
export function SectionHeading({
  id,
  title,
  eyebrow,
  lead,
  tone = 'light',
  align = 'left',
  className = ''
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  const centered = align === 'center';
  return <div className={`${centered ? 'mx-auto text-center' : ''} max-w-3xl ${className}`} data-id="element-140" data-mp="gjq09s9fm9g3">
      {eyebrow && <p className={`label-tech flex items-center gap-3 ${centered ? 'justify-center' : ''} ${dark ? 'text-brass-light' : 'text-brass'}`} data-id="element-141" data-mp="1titwawp8gvr">
          <span className="h-px w-6 shrink-0 bg-current" aria-hidden data-id="element-142" data-mp="uizggrxn13k2" />
          {eyebrow}
          {centered && <span className="h-px w-6 shrink-0 bg-current" aria-hidden data-id="element-143" data-mp="za7objjbkgv4" />}
        </p>}
      <h2 id={id} className={`text-balance font-brand text-[1.8rem] font-bold leading-[1.18] tracking-[-0.01em] min-[390px]:text-[1.95rem] sm:text-[2.45rem] lg:text-[2.75rem] ${eyebrow ? 'mt-4' : ''} ${dark ? 'text-ivory' : 'text-ink'}`} data-id="element-144" data-mp="1t9frj6lbr6j8">
        {title}
      </h2>
      {lead && <p className={`mt-4 text-[1rem] leading-relaxed sm:text-[1.06rem] ${centered ? 'mx-auto max-w-2xl' : 'max-w-2xl'} ${dark ? 'text-parchment' : 'text-stone'}`} data-id="element-145" data-mp="1y8a9y7fdqt2t">
          {lead}
        </p>}
    </div>;
}